import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { GALLERY } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/gallery/new")({
  component: () => <DeptContentForm cfg={GALLERY} />,
});
